import * as React from "react";
import * as ReactDOM from "react-dom";

import Examinator  from "../src/components/Examinator";


ReactDOM.render(<Examinator />,
    document.getElementById("custom-ui-container")
);
